module.exports = __webpack_public_path__ + "img/Scene-2.5eee0ca9.jpg";